module.exports = __webpack_public_path__ + "img/bs_logo_solution.204a386c.svg";